import { AGENT_EXTRA_TABS } from "@/components/agents/agent-extra-tabs";
import { createFileRoute, notFound } from "@tanstack/react-router";

/** `/agents/$slug/$tab`: a tab only some agents have (Hubert's sources, learnings). */
export const Route = createFileRoute("/_app/agents/$slug/$tab")({
  beforeLoad: ({ params }) => {
    if (!findTab(params.slug, params.tab)) throw notFound();
  },
  component: AgentExtraTabPage,
});

function findTab(slug: string, segment: string) {
  return AGENT_EXTRA_TABS[slug]?.find((t) => t.segment === segment);
}

function AgentExtraTabPage() {
  const { slug, tab } = Route.useParams();
  const Component = findTab(slug, tab)?.Component;
  return Component ? <Component /> : null;
}
